import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL } from '../../constant'
import axios from 'axios'

axios.defaults.withCredentials = true;

/**
 * FETCH ALL Couriers   
 */
 
export const fetchAllCouriers = createAsyncThunk('courier/fetchAllCouriers', async ({ token }, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + `/couriers`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});

/**
 * ADD NEW COURIER  
 */
 
export const addNewCourier = createAsyncThunk('courier/addNewCourier', async ({ token, data }, { rejectWithValue }) => {
    try {
        const res = await axios.post(API_BASE_URL + `/add-new-courier`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});

/**
 * UPDATE COURIER  
 */
 
export const updateCourier = createAsyncThunk('courier/updateCourier', async ({ token, data, id }, { rejectWithValue }) => {
    try {
        const res = await axios.post(API_BASE_URL + `/update-courier/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});